import { Divider, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useReducer, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaCheck, FaTimes, FaTrash } from "react-icons/fa";
import { RiAlertFill } from "react-icons/ri";
import CustomAlert from '../../componentes/alerts/CustomAlert';
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import DefaultButton from "../../componentes/button/DefaultButton";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import DefaultCard from '../../componentes/card/DefaultCard';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import MaterialPickingService from "./MaterialPickingService";

//#region STATE
const initialState = {
    nfNumber: "",
    totalVolume: "1",
    eanCode: "",
    isBip: false,
    currentStep: 1,
    idEntrega: 0,
    idSeparacao: 0,
    numeroVolume: "1",
    idNfeXML: 0,
    numeroNota: "",
    dataNota: "",
    nomeCliente: "",
    cidadeEnderecoCliente: "",
    ufEnderecoCliente: "",
    status: 1,
    error: false,
    success: false,
    warning: false,
    message: "",
    idSeparacaoExclusao: 0,
    numeroVolumeExclusao: ""
};
//#endregion

export default function MaterialPicking() {
    const { t } = useTranslation();
    const { control } = useForm();

    //#region REDUCER
    function reducer(state, action) {
        switch (action.type) {
            case "update": {
                return {
                    ...state,
                    ...action.payload
                };
            }
            case "clear": {
                return {
                    ...initialState,
                    open: true
                };
            }
            case "success": {
                return {
                    ...state,
                    warning: false,
                    success: true,
                    error: false,
                    message: action.message
                };
            }
            case "error": {
                return {
                    ...state,
                    warning: false,
                    success: false,
                    error: true,
                    message: action.message
                };
            }
            case "warning": {
                return {
                    ...state,
                    warning: true,
                    error: false,
                    success: false,
                    message: action.message
                };
            }
            case "close_alert": {
                return {
                    ...state,
                    success: false,
                    error: false,
                    warning: false
                };
            }
            default:
                throw new Error(`Invalid reducer action type: ${action.type}!`);
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);
    const [gridRestanteRows, setGridRestanteRows] = useState([]);
    const [gridVolumesRows, setGridVolumesRows] = useState([]);
    const [conteudoVolumeRows, setConteudoVolumeRows] = useState([]);
    const { nfNumber, totalVolume, eanCode, isBip, idEntrega, idSeparacao, numeroVolume, currentStep, idNfeXML, numeroNota, dataNota, nomeCliente, cidadeEnderecoCliente, ufEnderecoCliente, error, success, warning, message, idSeparacaoExclusao, numeroVolumeExclusao } = state;

    const userId = sessionStorage.getItem("userId");
    //#endregion

    //#region EVENTS
    const handleChange = (event) => {

        dispatch({
            type: "update",
            payload: { [event.target.name]: event.target.value }
        });


        if (event.target.name === "nfNumber") {
            // if (event.target.value !== nfNumber) {
            if (event.target.value.length === 44) {
                dispatch({
                    type: "update",
                    payload: { isBip: true }
                });
            }
        }

        // else if (event.target.name === "eanCode" && enterKeyPressed) {
        //     setTimeout(() => handleLeituraEan(event.target.value), 200);
        // }
    };


    function setError(message) {
        dispatch({ type: "error", message });
    }

    function setSuccess(message) {
        dispatch({ type: "success", message });
    }

    function handleCloseAlert() {
        dispatch({ type: "close_alert" });
    }


    async function handleSearch() {

        const request = { nfeBarcode: nfNumber }

        await MaterialPickingService
            .searchNF(request)
            .then((response) => {
                setTimeout(() => {
                    dispatch({
                        type: "update",
                        payload: {
                            idNfeXML: response.data.idNfeXML,
                            numeroNota: response.data.numeroNota,
                            dataNota: response.data.dataNota,
                            nomeCliente: response.data.nomeCliente,
                            cidadeEnderecoCliente: response.data.cidadeEnderecoCliente,
                            ufEnderecoCliente: response.data.ufEnderecoCliente,
                            currentStep: 2,
                            isBip: false
                        }
                    });
                }, 500);
            })
            .catch((e) => {
                setError(t("nfErrorSearch"));
            });
    };

    async function handleSearchVolumesState() {
        const request = { numeroNota: numeroNota }

        await MaterialPickingService
            .searchVolumes(request)
            .then((response) => {
                setGridVolumesRows(response.data);
            })
            .catch((e) => {
            });
    };

    async function handleSaveDelivery() {
        const request = {
            idNfeXML: idNfeXML,
            numeroNota: numeroNota,
            nomeCliente: nomeCliente,
            cidadeEnderecoCliente: cidadeEnderecoCliente,
            ufEnderecoCliente: ufEnderecoCliente,
            qtdeVolume: parseInt(totalVolume),
            idUsuLogado: userId
        }


        MaterialPickingService
            .saveClientDelivery(request)
            .then((response) => {
                dispatch({
                    type: "update",
                    payload: {
                        currentStep: 3,
                        idEntrega: response.data.idEntregaCliente,
                        totalVolume: (response.data.numeroVolume !== "" ? (parseInt(response.data.numeroVolume) + 1).toString() : '1'),
                        numeroVolume: (response.data.numeroVolume !== "" ? (parseInt(response.data.numeroVolume) + 1).toString() : '1')
                    }
                });
            })
            .catch((e) => {
                setError(t("saveError"));
            });
    };

    const handleAbrirVolume = () => {
        const request = {
            idNfeXML: idNfeXML,
            numeroNota: numeroNota,
            numeroVolume: numeroVolume,
            idUsuLogado: userId
        }

        MaterialPickingService
            .saveVolume(request)
            .then((response) => {
                dispatch({
                    type: "update",
                    payload: { idSeparacao: response.data.idSeparacao, totalVolume: numeroVolume }
                });

                handleSearchVolumesState();
                handleGetGridRestante();
            })
            .catch((e) => {
                setError(t("saveError"));
            });
    }

    function handleFecharVolume() {
        dispatch({
            type: "update",
            payload: { idSeparacao: 0, numeroVolume: (+gridVolumesRows[0].numeroVolume + +"1").toString(), eanCode: "" }
        });
        handleGetGridRestante();
        handleSearchVolumesState();
    }

    const [isInputEnabled, setIsInputEnabled] = useState(true);

    const reabrirVolume = (idSeparacao, volume) => {
        dispatch({
            type: "update",
            payload: {
                idSeparacao: idSeparacao,
                numeroVolume: volume
            }
        });
    };

    const excluirVolume = (idSeparacao, volume) => {
        MaterialPickingService
            .deletarVolume({ idSeparacao: idSeparacao, numeroNota: numeroNota })
            .then((response) => {
                if (response.data) {

                    dispatch({
                        type: "update",
                        payload: {
                            idSeparacao: 0,
                            numeroVolume: gridVolumesRows.some((item) => item.numeroVolume === numeroVolume) ? gridVolumesRows[0].numeroVolume : (numeroVolume - "1").toString(),
                            totalVolume: (gridVolumesRows[0].numeroVolume.toString() - "1")
                        }
                    });

                    handleSearchVolumesState();
                    handleGetGridRestante();
                }
            })
            .catch((e) => {
                setError(t("error"));
            });
    };

    function validateBoxReading(valueRead) {
        return gridRestanteRows.some(e => e.eanCaixa === valueRead);
    }

    const handleLeituraEan = (valueRead) => {
        const isBoxReading = validateBoxReading(valueRead);

        const request = {
            eanBipado: valueRead,
            idSeparacao: idSeparacao,
            idUsuLogado: userId
        }

        MaterialPickingService
            .qtdLida(request)
            .then((response) => {

                if (response.data.resultado === 1) {
                    setIsInputEnabled(true);

                    dispatch({ type: "warning", message: t("AlertEan") });

                    MaterialPickingService
                        .leituraEan(request)
                        .then((response) => {
                            if (isBoxReading) {
                                setTimeout(() => {
                                    handleFecharVolume();
                                }, 50)
                            } else {

                                dispatch({
                                    type: "update",
                                    payload: {
                                        idSeparacao: response.data.idSeparacao,
                                        eanCode: ""
                                    }
                                });

                                handleGetGridRestante();
                                handleSearchVolumesState();
                            }
                        })
                        .catch(() => {
                            setError(t("saveError"));
                            dispatch({
                                type: "update",
                                payload: { eanCode: "" }
                            });
                        });
                } else if (response.data.resultado === 0) {
                    setIsInputEnabled(true);

                    MaterialPickingService
                        .leituraEan(request)
                        .then((response) => {
                            if (isBoxReading) {
                                setTimeout(() => {
                                    handleFecharVolume();
                                }, 50)
                            } else {

                                dispatch({
                                    type: "update",
                                    payload: { idSeparacao: response.data.idSeparacao, eanCode: "" }
                                });

                                handleGetGridRestante();
                                handleSearchVolumesState();
                            }
                        })
                        .catch((e) => {
                            setError(t("saveError"));
                            dispatch({
                                type: "update",
                                payload: { eanCode: "" }
                            });
                        });

                } else if (response.data.resultado === 2) {


                    setSuccess(t("AlertEanFim"));

                    dispatch({
                        type: "update",
                        payload: { eanCode: "" }
                    });

                } else {
                    setError(t("error"));
                }
            })
            .catch((e) => {

            });

        // MaterialPickingService
        //     .qtdRequerida(request)
        //     .then((response) => {
        //         handleCloseAlert();
        //         dispatch({
        //             type: "Al"
        //         })
        //     }
        //     )
        //     .catch((e) => {
        //         setError(t("saveError"));
        //         dispatch({
        //             type: "update",
        //             payload: { eanCode: "" }
        //         });
        //     });

        // MaterialPickingService
        //     .leituraEan(request)
        //     .then((response) => {
        //         dispatch({
        //             type: "update",
        //             payload: { idSeparacao: response.data.idSeparacao, eanCode: "" }
        //         });

        //         handleGetGridRestante();
        //     })
        //     .catch((e) => {
        //         setError(t("saveError"));
        //         dispatch({
        //             type: "update",
        //             payload: { eanCode: "" }
        //         });
        //     });
    }

    const handleGetGridRestante = () => {
        const request = {
            idEntregaCliente: idEntrega,
            idUsuLogado: userId
        }

        MaterialPickingService
            .handleGetGrid(request)
            .then((response) => {
                setGridRestanteRows(response.data);
            })
            .catch((e) => {
                setError(t("saveError"));
            });
    }

    const handleCellClickItemVolumes = (param, event) => {
        const request = {
            idSeparacao: param.data.idSeparacao,
        }

        MaterialPickingService
            .getListaPorVolume(request)
            .then((response) => {
                dispatch({
                    type: "update",
                    payload: {
                        idSeparacaoExclusao: param.data.idSeparacao
                        , numeroVolumeExclusao: param.data.numeroVolume
                    }
                });
                setConteudoVolumeRows(response.data);
            })
            .catch((e) => {
            });
    }

    const handleDeletarLeitura = (idSeparacaoLog, idSeparacaoItens, qtdeLida) => {
        const request = {
            idSeparacaoItens: idSeparacaoItens,
            idSeparacaoLog: idSeparacaoLog,
            qtdeLida: qtdeLida
        }

        MaterialPickingService
            .deleteLeitura(request)
            .then((response) => {
                handleGetGridRestante();
                dispatch({
                    type: "update",
                    payload: { idSeparacaoExclusao: 0, numeroVolumeExclusao: "" }
                });
                setConteudoVolumeRows([]);

            })
            .catch((e) => {
                setError(t("saveError"));
            });
    }

    const canFinalize = () => {
        return gridVolumesRows.some((e) => e.statusVolume === 0) ? false : true;
    };

    const handleFinalizarEntrega = () => {
        if (canFinalize()) {
            const request = {
                idEntregaCliente: idEntrega,
                qtdeVolume: parseInt(totalVolume)
            }

            MaterialPickingService
                .finalizarEntrega(request)
                .then((response) => {

                    dispatch({
                        type: "clear",
                    });

                    setConteudoVolumeRows([]);
                    setGridRestanteRows([]);
                    setGridVolumesRows([]);
                })
                .catch((e) => {
                    setError(t("saveError"));
                });
        } else {
            let volumesVazios = [];
            volumesVazios = gridVolumesRows.filter((volume) => volume.statusVolume === 0);
            const result = volumesVazios.map(item => item.numeroVolume.toString()).join(",");

            setError(t("finalizeDeliveryError").replace("{0}", result))
        }
    }

    useEffect(() => {
        if (nfNumber !== "" && isBip) {
            handleSearch();
        }
    }, [isBip]);

    useEffect(() => {
        if (numeroVolume !== "" && idSeparacao === 0) {
            handleSearchVolumesState();
        }
    }, [numeroVolume, idSeparacao]);

    //#endregion


    //#region COLUMNS 
    const columnsGridRestantes = (t) => [
        {
            field: "status",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="status" />;
            },
            template: (params) => (
                <>
                    {params.qtdeLida === 0 ? <FaTimes color={"#d9534f"} size={35} /> : null}
                    {params.qtdeLida !== 0 && params.qtdeLida < params.qtdeItensUnitariosNecessarios ? <RiAlertFill color={"#FFC107"} size={35} /> : null}
                    {params.qtdeLida >= params.qtdeItensUnitariosNecessarios ? <FaCheck color={"#5cb85c"} size={35} /> : null}
                </>
            )
        },
        {
            field: "descProduto",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="Desc. Produto" />;
            },
        },
        {
            field: "qtdeLida",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="Qtde Lida" />;
            },
        },
        {
            field: "qtdeItensUnitariosNecessarios",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="qtdeItensUnitariosNecessarios" />;
            },
        }
    ];

    const columnsGridVolumesRows = (t) => [
        {
            field: "numeroVolume",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="numeroVolume" />;
            },
        },
        {
            field: "statusVolume",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="status" />;
            },
            template: (params) => {
                return (
                    <>
                        {params.statusVolume === 0 ? <FaTimes color={"#d9534f"} size={35} /> : null}
                        {params.statusVolume === 1 ? <FaCheck color={"#5cb85c"} size={35} /> : null}
                    </>
                )
            }
        },
        {
            field: "reabrirVolume",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} />;
            },
            template: (params) => {
                return (
                    <>
                        <DefaultButton
                            labelName={"Reabrir"}
                            className="primaryButton"
                            onClick={() => reabrirVolume(params.idSeparacao, params.numeroVolume)}
                        />
                    </>
                )
            }
        },
        {
            field: "excluirVolume",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} />;
            },
            template: (params) => {
                return (
                    <>
                        {params.numeroVolume !== numeroVolume ? (
                            <DefaultButton
                                labelName={"Excluir"}
                                className="primaryButton"
                                onClick={() => excluirVolume(params.idSeparacao, params.numeroVolume)}
                            />
                        )
                            :
                            null
                        }
                    </>
                )
            }
        }
    ];

    const columnsLeiturasVolume = (t) => [
        {
            field: "descProduto",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="Desc. Produto" />;
            },
        },
        {
            field: "qtdeLida",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="Qtde Lida" />;
            },
        },
        {
            field: "tipoEan",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="Tipo" />;
            },
        },
        {
            field: "removerLeitura",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="RemoverLeitura" />;
            },
            template: (params) => (
                <>
                    <FaTrash color={"#000000"} size={30} onClick={() => { handleDeletarLeitura(params.idSeparacaoLog, params.idSeparacaoItens, params.qtdeLida) }} />
                </>
            )
        },
    ];


    //#endregion


    //#region COMPONENTS
    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="materialPicking"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                success={success}
                                error={error}
                                message={message}
                                warning={warning}
                                handleCloseAlert={handleCloseAlert}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>

                                <Grid item xs={6}>
                                    <Grid sm={12}>
                                        <DefaultCard style={{ display: "block", width: "100%", height: "400px", marginBottom: "25px", border: "1px solid", }}
                                            content={
                                                <>
                                                    <GridInputRow>
                                                        <Grid item xs={12}>
                                                            <IconLabelSwitch
                                                                size={20}
                                                                name={currentStep > 1 ? "active" : "canceled"}
                                                                variant={"h6"}
                                                                customLabel={t("Informações da nota")}
                                                            />
                                                        </Grid>
                                                    </GridInputRow>
                                                    <GridInputRow>
                                                        <Grid item md={12}>
                                                            <InputField
                                                                name="nfNumber"
                                                                control={control}
                                                                defaultValue=""
                                                                // onKeyPress={(e) => {
                                                                //     if (e.key === 'Enter') {
                                                                //         handleChange();


                                                                //     }
                                                                // }
                                                                // }
                                                                onChange={handleChange}
                                                                value={nfNumber}
                                                                length={100}
                                                                error={error}
                                                            />
                                                        </Grid>

                                                    </GridInputRow>

                                                    {currentStep >= 2 ?
                                                        <GridInputRow>
                                                            <Grid item md={3}>
                                                                <InputField
                                                                    name="totalVolume"
                                                                    control={control}
                                                                    defaultValue=""
                                                                    input="number"
                                                                    onChange={handleChange}
                                                                    disabled={true}
                                                                    value={totalVolume}
                                                                    length={100}
                                                                    error={error}
                                                                />

                                                            </Grid>
                                                            <Grid item md={6}></Grid>
                                                            <Grid item md={3}>
                                                                <DefaultButton labelName={"iniciar entrega"} className="primaryButton" onClick={handleSaveDelivery} />
                                                            </Grid>

                                                        </GridInputRow>
                                                        : null
                                                    }

                                                    <GridInputRow>
                                                        <Grid item md={12}>
                                                            <Divider></Divider>
                                                        </Grid>
                                                    </GridInputRow>
                                                    {numeroNota !== "" ? (
                                                        <>
                                                            <GridInputRow>
                                                                <Typography
                                                                    style={{ marginTop: "20px" }}
                                                                    variant="subtitle1"
                                                                    sx={{ mt: 5 }}
                                                                >
                                                                    <strong>{t("nf")}</strong> {numeroNota}
                                                                </Typography>
                                                            </GridInputRow>

                                                            <GridInputRow>
                                                                <Typography
                                                                    style={{ marginTop: "20px" }}
                                                                    variant="subtitle1"
                                                                    sx={{ mt: 5 }}
                                                                >
                                                                    <strong>{t("nfDate")}</strong> {dataNota}
                                                                </Typography>
                                                            </GridInputRow>

                                                            <GridInputRow>
                                                                <Typography
                                                                    style={{ marginTop: "20px" }}
                                                                    variant="subtitle1"
                                                                    sx={{ mt: 5 }}
                                                                >
                                                                    <strong>{t("nfClient")}</strong> {nomeCliente}
                                                                </Typography>
                                                            </GridInputRow>

                                                            <GridInputRow>
                                                                <Typography
                                                                    style={{ marginTop: "20px" }}
                                                                    variant="subtitle1"
                                                                    sx={{ mt: 5 }}
                                                                >
                                                                    <strong>{t("nfCityUF")}</strong> {cidadeEnderecoCliente + "/" + ufEnderecoCliente}
                                                                </Typography>
                                                            </GridInputRow>
                                                        </>
                                                    ) : null}

                                                </>
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                {currentStep >= 3 ? (

                                    <Grid item xs={6}>
                                        <Grid sm={12}>
                                            <DefaultCard style={{ display: "block", width: "100%", height: "400px", marginBottom: "25px", border: "1px solid", }}
                                                content={
                                                    <>
                                                        <Grid
                                                            item
                                                            container
                                                            spacing={1}>
                                                            <Grid item xs={12}>
                                                                <IconLabelSwitch
                                                                    size={20}
                                                                    name={currentStep < 3 ? "active" : "canceled"}
                                                                    variant={"h6"}
                                                                    customLabel={t("Leitura de produtos")}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            container
                                                            spacing={1}
                                                            style={{ marginTop: "20px" }}>
                                                        </Grid>

                                                        {idSeparacao == 0 ?
                                                            <>
                                                                <GridInputRow>
                                                                    <Grid item md={12}>
                                                                        <InputField
                                                                            name="numeroVolume"
                                                                            control={control}
                                                                            defaultValue=""
                                                                            input="numeroVolume"
                                                                            onChange={handleChange}
                                                                            value={numeroVolume}
                                                                            length={100}
                                                                            error={error}
                                                                            disabled={true}
                                                                            label={"Número do volume"}
                                                                        />
                                                                    </Grid>
                                                                </GridInputRow>
                                                                <GridInputRow>
                                                                    <Grid item md={6}>
                                                                        <DefaultButton
                                                                            labelName={"Abrir volume"}
                                                                            onClick={handleAbrirVolume}
                                                                            className="primaryButton"
                                                                        ></DefaultButton>
                                                                    </Grid>

                                                                    <Grid item md={6}>
                                                                        <DefaultButton
                                                                            style={{ backgroundColor: "#000766" }}
                                                                            labelName={"Finalizar Entrega"}
                                                                            className="primaryButton"
                                                                            onClick={() => {
                                                                                handleFinalizarEntrega()
                                                                            }}
                                                                        ></DefaultButton>
                                                                    </Grid>
                                                                </GridInputRow>
                                                            </>
                                                            :
                                                            <>
                                                                <GridInputRow>
                                                                    <Grid item md={6}>
                                                                        <Typography variant="h6">
                                                                            Volume atual: {numeroVolume}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item md={3}></Grid>

                                                                </GridInputRow>

                                                                <GridInputRow>
                                                                    <Grid item md={12}>
                                                                        <InputField
                                                                            name="eanCode"
                                                                            control={control}
                                                                            defaultValue=""
                                                                            input="eanCode"
                                                                            inputProps={
                                                                                {
                                                                                    onKeyDown: (e) => {
                                                                                        if (e.key === 'Enter') {
                                                                                            setTimeout(() => handleLeituraEan(eanCode), 200);
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            onChange={handleChange}
                                                                            value={eanCode}
                                                                            length={100}
                                                                            error={error}
                                                                            disabled={!isInputEnabled}
                                                                            autoFocus={true}
                                                                        />
                                                                    </Grid>
                                                                </GridInputRow>
                                                                <GridInputRow>
                                                                    <Grid item md={6}>
                                                                        <DefaultButton
                                                                            labelName={"Fechar volume"}
                                                                            className="primaryButton"
                                                                            onClick={handleFecharVolume}
                                                                        ></DefaultButton>
                                                                    </Grid>
                                                                    <Grid item md={6}>
                                                                        <DefaultButton
                                                                            style={{ backgroundColor: "#000766" }}
                                                                            labelName={"Finalizar Entrega"}
                                                                            className="primaryButton"
                                                                            onClick={() => {
                                                                                handleFinalizarEntrega()
                                                                            }}
                                                                        ></DefaultButton>
                                                                    </Grid>

                                                                </GridInputRow>
                                                            </>
                                                        }
                                                    </>
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                ) : null}

                            </GridInputRow>
                            {gridRestanteRows.length > 0 ?
                                <GridInputRow>
                                    <Grid item md={6}>
                                        <DefaultCard style={{ display: "block", width: "100%", height: "400px", marginBottom: "25px", border: "1px solid", overflow: "auto" }}
                                            content={
                                                <>
                                                    <GridInputRow>
                                                        <Grid item md={12}>

                                                            <IconLabelSwitch
                                                                size={20}
                                                                variant={"h6"}
                                                                customLabel={t("informacoesItensReqLidos")}
                                                            />
                                                        </Grid>
                                                    </GridInputRow>
                                                    <GridInputRow>
                                                        {gridRestanteRows.length > 0 ?
                                                            <Grid item md={12}>
                                                                <DefaultDatagrid
                                                                    columns={columnsGridRestantes(t)}
                                                                    dataSource={gridRestanteRows}
                                                                    allowPaging={false}
                                                                />
                                                            </Grid>

                                                            : null}

                                                    </GridInputRow>
                                                </>
                                            } />
                                    </Grid>
                                    <Grid item md={6}>
                                        <DefaultCard style={{ display: "block", width: "100%", height: "400px", marginBottom: "25px", border: "1px solid", overflow: "auto" }}
                                            content={
                                                <>
                                                    <GridInputRow>
                                                        <Grid item md={12}>

                                                            <IconLabelSwitch
                                                                size={20}
                                                                variant={"h6"}
                                                                customLabel={t("informacoesVolume")}
                                                            />
                                                        </Grid>
                                                    </GridInputRow>
                                                    <GridInputRow>

                                                        {gridVolumesRows.length > 0 && idSeparacaoExclusao === 0 ?

                                                            <Grid item md={12}>
                                                                <DefaultDatagrid
                                                                    columns={columnsGridVolumesRows(t)}
                                                                    dataSource={gridVolumesRows}
                                                                    cellSelected={handleCellClickItemVolumes}
                                                                    allowPaging={false}
                                                                />
                                                            </Grid>

                                                            : null}
                                                        {conteudoVolumeRows.length > 0 ?
                                                            <Grid item md={12}>
                                                                <GridInputRow>
                                                                    <Grid item md={10}>
                                                                        <Typography>
                                                                            Conteúdo do volume: {numeroVolumeExclusao}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item md={2}>
                                                                        <DefaultButton
                                                                            labelName={"voltar"}
                                                                            className="primaryButton"
                                                                            onClick={() => {
                                                                                dispatch({
                                                                                    type: "update",
                                                                                    payload: { idSeparacaoExclusao: 0, numeroVolumeExclusao: "" }
                                                                                });
                                                                                setConteudoVolumeRows([]);
                                                                            }}
                                                                        ></DefaultButton>
                                                                    </Grid>
                                                                    <Grid item md={12}>
                                                                        <Divider />
                                                                    </Grid>
                                                                </GridInputRow>
                                                                <GridInputRow>
                                                                    <Grid item md={12}>
                                                                        <DefaultDatagrid
                                                                            columns={columnsLeiturasVolume(t)}
                                                                            dataSource={conteudoVolumeRows}
                                                                            allowPaging={false}
                                                                        />
                                                                    </Grid>
                                                                </GridInputRow>
                                                            </Grid> :
                                                            null}
                                                    </GridInputRow>
                                                </>
                                            } />
                                    </Grid>
                                </GridInputRow>
                                : null}

                        </GridItemContainer>
                    </>
                }
            />
        </>
    );
};
//#endregion
